export default [
    {
        id: 'tax',
        name: 'Отчисления',
        icon: require('./images/003-money.png')
    },
    {
        id: 'officeService',
        name: 'Офис',
        icon: require('./images/004-chair.png')
    },
    {
        id: 'depreciation',
        name: 'Амортизация',
        icon: require('./images/005-mouse.png')
    },
    {
        id: 'administration',
        name: 'Админи-вание',
        icon: require('./images/006-pencil.png')
    }
]
